/* src/app/ai-sourcing/ai-sourcing-review/ai-sourcing-review.component.scss */
#overlay {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 6;
  top: 0;
  left: 0px;
  background-color: #000;
  opacity: 0.4;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 30px;
  display: none;
}
#quickView {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 6;
  top: 0;
  right: -60px;
  background-color: #fff;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 0px 0px;
}
.wc-checkbox {
  width: 14px !important;
  height: 14px !important;
  margin-top: 3px;
}
.wc-checkbox input[type=checkbox] {
  width: 14px !important;
  height: 14px !important;
}
.wc-checkbox input[type=checkbox]:checked ~ i {
  background-color: #2e93a1;
  border: 1px solid #2e93a1;
  transition: 0.5s;
}
.wc-checkbox i {
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #FFF;
  border: 1px solid #2e93a1;
  border-radius: 2px;
}
@media only screen and (max-width: 1368px) {
  .wc-checkbox {
    width: 14px !important;
    height: 14px !important;
  }
  .wc-checkbox input[type=checkbox] {
    width: 14px !important;
    height: 14px !important;
  }
  .wc-checkbox input[type=checkbox]:checked ~ i {
    background-color: #2e93a1;
    border: 1px solid #2e93a1;
    transition: 0.5s;
  }
  .wc-checkbox i {
    width: 100%;
    height: 100%;
    background-color: #fff;
    color: #FFF;
    border: 1px solid #2e93a1;
    border-radius: 2px;
  }
}
.lavender-circle {
  background-color: #E1D8E9 !important;
  color: #725190 !important;
}
.yellow-circle {
  background-color: #FFF9D7 !important;
  color: #E0BF00 !important;
}
.blue-circle {
  background-color: #B9D4F4;
  color: #1C5FB0;
}
.pink-circle {
  background-color: #FBDAE7;
  color: #A5124D;
}
.card-c .teal-circle {
  color: #34A853 !important;
  background-color: #EBF6EE;
}
.more-ai-matched-card {
  border: 1px solid #9CD1FF;
  background:
    linear-gradient(
      90deg,
      rgba(108, 189, 255, 0.2) -1.65%,
      rgb(255, 255, 255) 80%);
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.more-ai-matched-card p {
  font-size: 12px;
  font-weight: normal;
  line-height: 1;
  margin-bottom: 0;
}
.more-ai-matched-card .btn-get-more-candidate {
  background-color: #F2F2F2;
  color: #969696;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 8px;
  border: none;
  outline: none;
}
.more-ai-matched-card .btn-get-more-candidate:focus {
  outline: none;
}
.more-ai-matched-card .btn-get-more-candidate.active {
  background-color: #2e93a1;
  color: #ffffff;
}
.empty-card {
  border: 1px solid rgba(46, 147, 161, 0.3019607843);
  background:
    linear-gradient(
      183.08deg,
      rgba(163, 255, 226, 0.45) -58.69%,
      rgba(255, 255, 250, 0.45) 53.16%,
      rgba(255, 245, 134, 0.45) 164.33%);
  padding: 30px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #484b59;
}
.empty-card div {
  width: 60%;
}
.empty-card span.text-center {
  display: flex;
  justify-content: center;
  font-size: 30px;
}
.empty-card p {
  text-align: center;
  line-height: 1.6;
}
.archive {
  color: rgba(205, 15, 15, 0.5411764706) !important;
  border-color: rgba(205, 15, 15, 0.5411764706) !important;
}
::-webkit-scrollbar {
  width: 4px;
}
:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
::-webkit-scrollbar-track {
  background: white !important;
}
::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.ai-sourcing-alert {
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2509803922);
  background: #FFFFFF;
  padding: 10px;
  max-width: auto;
  width: -moz-fit-content;
  width: fit-content;
  position: fixed;
  border: 1px solid transparent;
  border-radius: 2px;
  left: 0%;
  right: 0%;
  top: 90px;
  margin: 0 auto;
  font-size: 12px;
  z-index: 1;
  color: #484b59;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
}
.close-alert {
  color: #2e93a1;
  font-weight: 500;
  font-size: 12px;
  cursor: pointer;
  margin-left: 15px;
}
.img-config {
  width: 200px;
  height: 180px;
}
.criteria-btn {
  width: 200px;
  background-color: #2E93A1;
  color: #ffffff;
}
.progress-text {
  font-size: 14px;
  font-weight: 500;
  color: #2E93A1;
  min-width: 35px;
}
.progress-container {
  display: inline-flex;
  align-items: center;
  margin-left: 12px;
}
.circular-progress {
  position: relative;
  width: 30px;
  height: 30px;
  margin: 0 8px;
}
.circular-progress svg {
  transform: rotate(-90deg);
}
.circular-progress-bg {
  fill: none;
  stroke: #e9ecef;
  stroke-width: 3;
}
.circular-progress-fill {
  fill: none;
  stroke: #2E93A1;
  stroke-width: 3;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.3s ease;
}
.status-btn {
  padding: 0 6px 0 6px;
  border-radius: 3px;
}
.live-status {
  background-color: #dcf3d1;
  color: #229300;
  font-size: 14px;
  font-weight: 500;
}
.img-config-review {
  width: 170px;
  height: 130px;
}
.backdrop-blur {
  display: block;
  visibility: visible;
  position: relative;
  top: 0px;
  left: 0%;
  bottom: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.05);
  -webkit-backdrop-filter: blur(0px);
  backdrop-filter: blur(0px);
  z-index: 5;
  opacity: 1;
  pointer-events: none;
  background-color: red;
  background-image: url("./media/blur-image-3ERODAFJ.png");
  background-size: cover;
  background-position: left top;
  background-repeat: no-repeat;
}
.sub-modal {
  padding: 15px;
  border-radius: 4px;
  z-index: 6;
  position: absolute;
  left: 50%;
  top: 100px;
  display: block;
  visibility: visible;
  opacity: 1;
  margin-top: -1px;
  pointer-events: none;
  transform: translateX(-50%);
  width: 435px;
  height: 435px;
  background-color: #ffffff;
}
.alert-dismissible .btn-close {
  display: none !important;
}
/*# sourceMappingURL=ai-sourcing-review.component-T43KDJVY.css.map */
